module.exports = __webpack_public_path__ + "static/media/dropdown.0c30bc7c.svg";